// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__G6MyZ","title":"ClientCherryInfo_title__FlWl6","itemText":"ClientCherryInfo_itemText__3S9f2"};